import React from 'react';
import { injectIntl } from 'react-intl';
import { getFilterSummaryDate } from 'components/Charts/formatters';
import FlowChart from 'components/Charts/FlowChart';
import ChartSubtitles from 'components/Charts/ChartSubtitles';

import messages from './messages';
import './page-flow.less';

const hasPages = pages => pages.filter(p => p.url !== 'exit').length;
const BASE_PAGE_HEIGHT = 70;

const PageflowResult = ({
  intl: { formatMessage: $t },
  title,
  segments = [],
  contentSettings,
  onContentSettingsChanged,
}) => {
  const nextPageContentSettings = {
    pageflow: {
      minInteraction: contentSettings.pageflow.minInteraction + 1,
      maxInteraction: contentSettings.pageflow.maxInteraction + 1,
    },
  };
  const previousPageContentSettings = {
    pageflow: {
      minInteraction: contentSettings.pageflow.minInteraction - 1,
      maxInteraction: contentSettings.pageflow.maxInteraction - 1,
    },
  };

  return (
    <>
      {segments.map((segment, index) => {
        const handlePrev = contentSettings.pageflow.minInteraction > 1
          ? () => onContentSettingsChanged(previousPageContentSettings)
          : false;

        const handleNext = segment.values.length && hasPages(segment.values[segment.values.length - 1].pages)
          ? () => onContentSettingsChanged(nextPageContentSettings)
          : false;

        const chartHeight = Math.max(...segment.values.map(({ pages }) => pages.length)) * BASE_PAGE_HEIGHT;
        const pageflowHeaders = segment.values.map(({ interaction, pages }) => {
          if (!hasPages(pages)) { return ''; }
          if (interaction === 1) { return $t(messages.entryPage); }
          return `${$t(messages.page)} ${interaction}`;
        });

        return (
          <div key={index} className="pageflow-chart">
            <ChartSubtitles subTitles={[`${segment.name} - ${getFilterSummaryDate(segment)}`]} />
            <div className="pageflow-chart__pages">
              {pageflowHeaders.map((page, i) => (<div key={i}>{page}</div>))}
            </div>
            <FlowChart
              title={title}
              segment={segment}
              handlePrev={handlePrev}
              handleNext={handleNext}
              height={chartHeight}
            />
          </div>
        );
      })}
    </>
  );
};

export default injectIntl(PageflowResult);
